import { createFileRoute } from '@tanstack/react-router'
import { Console } from '@/features/console/Console'
import { roomSearch } from '@/lib/roomSearch'

/**
 * O lado da terapeuta na medição de deriva entre duas máquinas.
 *
 * É a única entrada anônima do console: sala pela query string, sem sessão
 * marcada e sem login. Só funciona enquanto `BIA_ROOM_ALLOW_ANONYMOUS`
 * estiver ligado, o que fora de desenvolvimento não acontece.
 *
 * Fora da camada `_app` porque não há sessão de terapeuta para guardar, e
 * fora do `KeyGate` porque sem paciente não há DEK: no modo anônimo a tela
 * não registra medida nem nota rápida.
 */
export const Route = createFileRoute('/measure_/sala')({
  validateSearch: roomSearch,
  component: function SalaDeMedicao() {
    const { room, measure, label } = Route.useSearch()
    return (
      <div data-surface="consultorio" className="h-full">
        <Console key={room} roomId={room} measure={measure} label={label ?? ''} />
      </div>
    )
  },
})
